/**
 * Enum for registration step code names.
 * @readonly
 * @enum {string}
 */
export default Object.freeze({
  Activation: 'Activation',
  ComplianceApproval: 'ComplianceApproval',
  ConsultantApproval: 'ConsultantApproval',
  Interview: 'Interview',
  OnlineRegistration: 'OnlineRegistration',
  PhoneScreen: 'PhoneScreen',
  ReferenceChecks: 'ReferenceChecks',
  ResourceManagerApproval: 'ResourceManagerApproval',
  WelcomeEmail: 'WelcomeEmail',
  R2WLoginCreation: 'R2WLoginCreation',
})
